import { render } from "./CardBannerPagamento.vue?vue&type=template&id=576bc50b&scoped=true"
import script from "./CardBannerPagamento.vue?vue&type=script&lang=js"
export * from "./CardBannerPagamento.vue?vue&type=script&lang=js"

import "./CardBannerPagamento.vue?vue&type=style&index=0&id=576bc50b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576bc50b"]])

export default __exports__